module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-quizz"
    }
  }, [(!_vm.isDone) ? _c('div', [_vm._l((_vm.fields), function(field) {
    return _c('div', {
      key: field.id,
      staticClass: "form-group field"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": 'quizz-text-' + field.id
      }
    }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), (field.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fieldModels[field.id]),
        expression: "fieldModels[field.id]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "value": "",
        "id": 'quizz-text-' + field.id,
        "name": 'quizz-text-' + field.id,
        "placeholder": field.placeholder ? field.placeholder : ''
      },
      domProps: {
        "value": (_vm.fieldModels[field.id])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fieldModels, field.id, $event.target.value)
        }, function($event) {
          _vm.updateModel(_vm.fieldModels, field.id, $event.target.value)
        }]
      }
    }) : (field.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fieldModels[field.id]),
        expression: "fieldModels[field.id]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "min": field.min,
        "max": field.max,
        "id": 'quizz-text-' + field.id,
        "name": 'quizz-text-' + field.id
      },
      domProps: {
        "value": (_vm.fieldModels[field.id])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fieldModels, field.id, $event.target.value)
        }, function($event) {
          _vm.updateModel(_vm.fieldModels, field.id, $event.target.value)
        }]
      }
    }) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.questions), function(question) {
    return _c('question', {
      key: question.id,
      attrs: {
        "question": question,
        "cdn": _vm.cdn
      },
      on: {
        "input": function($event) {
          _vm.updateModel(_vm.questionModels, question.id, $event)
        }
      },
      model: {
        value: (_vm.questionModels[question.id]),
        callback: function($$v) {
          _vm.$set(_vm.questionModels, question.id, $$v)
        },
        expression: "questionModels[question.id]"
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h3', [_vm._v(_vm._s(_vm.form.titre))]), _vm._v(" "), (_vm.isCheckEmail) ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.form.email))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "nom@example.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "optins"
  }, _vm._l((_vm.lists), function(list) {
    return (list.optin) ? _c('div', {
      staticClass: "optin"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.optinModels[list.id]),
        expression: "optinModels[list.id]"
      }],
      staticClass: "optin-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'optin-' + list.id
      },
      domProps: {
        "checked": Array.isArray(_vm.optinModels[list.id]) ? _vm._i(_vm.optinModels[list.id], null) > -1 : (_vm.optinModels[list.id])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.optinModels[list.id],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.optinModels[list.id] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.optinModels[list.id] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.optinModels, list.id, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "optin-label",
      attrs: {
        "for": 'optin-' + list.id
      },
      domProps: {
        "innerHTML": _vm._s(list.label)
      }
    })]) : _vm._e()
  })), _vm._v(" "), (!_vm.isLoading) ? _c('button', {
    ref: "submitButton",
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isDone
    },
    on: {
      "click": _vm.sendResults
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.bouton) + "\n            ")]) : _c('div', {
    staticClass: "loader"
  }), _vm._v(" "), (_vm.showError) ? _c('div', {
    attrs: {
      "id": "error"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.form['sous-bouton']) ? _c('div', {
    staticClass: "after-submit-button",
    domProps: {
      "innerHTML": _vm._s(_vm.form['sous-bouton'])
    }
  }) : _vm._e()])], 2) : _c('div', [(_vm.greetings) ? _c('span', {
    staticClass: "greetings",
    domProps: {
      "innerHTML": _vm._s(_vm.greetings)
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.formatResult) ? _c('span', {
    staticClass: "resultat",
    domProps: {
      "innerHTML": _vm._s(_vm.formatResult)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d23a86d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quizz.vue
// module id = 18
// module chunks = 0